import { useAppVersionWatcher } from './useAppVersionWatcher';

export function AppVersionWatcher() {
  useAppVersionWatcher();
  return null;
}
